import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography } from '@mui/material';
import { formatDate } from '../../../utils/DateUtils';
import { getStatusById, getPositionById } from '../../../utils/Enums';

const ProfessionalInfoCard = ({ user }) => {
  const { t } = useTranslation();

  const getStatusLabel = (statusId) => {
    const status = getStatusById(statusId);
    return status ? (
      <span className="roboto-light" style={{ color: status.color }}>
        {t(status.label)}
      </span>
    ) : null;
  };

  const getPositionLabel = (positionId) => {
    const position = getPositionById(positionId);
    return position ? (
      <span className="roboto-light">
        {t(position.label)}
      </span>
    ) : null;
  };

  if (!user) {
    return null; // or a loading spinner, or a placeholder component
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div"><span className="roboto-light">{t('professional_information')}</span></Typography>
        <Typography variant="body2" style={{ paddingTop: '20px' }}>
          <p><span className="roboto-regular">{t('supervisor')}:</span><span className="roboto-light"> PENDING</span></p>
          <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('started_date')}:</span><span className="roboto-light"> {formatDate(user.dateOfAdmission)}</span></p>
          <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('position')}:</span> {getPositionLabel(user.position)}</p>
          <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('role')}:</span><span className="roboto-light"> {user.role.name}</span></p>
          <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('status')}:</span> {getStatusLabel(user.status)}</p>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ProfessionalInfoCard;
